type DateSequence = 'MDY' | 'DMY' | 'YDM' | 'YMD';

const getDateString = (date: any, sequence: DateSequence, delimiter: string) => {
  const { month, day, year } = getDateParts(date);
  
  let dateString;
  switch (sequence) {
    case 'MDY':
      dateString = [month, day, year].join(delimiter);
      break;
    case 'DMY':
      dateString = [day, month, year].join(delimiter);
      break;
    case 'YDM':
      dateString = [year, day, month].join(delimiter);
      break;
    case 'YMD':
      dateString = [year, month, day].join(delimiter);
      break;
  }

  return dateString;
}

const getDateObject = (str: string, sequence: DateSequence, delimiter: string) => {
  const dateArray = str.split(delimiter);
  const monthIndex = sequence === 'MDY' ? 0 : 1;
  const dayIndex = sequence === 'DMY' ? 0 : sequence === 'YDM' ? 2 : 1;
  const yearIndex = sequence === 'YMD' ? 0 : 2;
  const dateObject = new Date(+dateArray[yearIndex], +dateArray[monthIndex] - 1, +dateArray[dayIndex]);

  return dateObject;
}

const getDateParts = (date: any) => {
  let day = date.getDate();
  let month = date.getMonth() + 1;
  const year = date.getFullYear();

  if (day < 10) day = "0" + day;
  if (month < 10) month = "0" + month;

  return {month, day, year};
}

export const InputMasks = {
  CURRENCY: {
    mask: '$VALUE',
    lazy: false,
    blocks: {
      VALUE: {
        mask: Number,
        scale: 2,
        signed: false,
        thousandsSeparator: ',',
        padFractionalZeros: true,
        radix: '.',
      }
    }
  },
  SSN: {
    mask: '000-00-0000',
    lazy: false
  },
  SECURED_SSN: {
    mask: 'VALUE',
    lazy: false,
    blocks: {
      VALUE: {
        mask: '000-00-0000',
        blocks: {
          0: {
            mask: '0',
            displayChar: '\u2022',
          }
        }
      }
    }
  },
  EIN: {
    mask: '00-0000000',
    lazy: false,
  },
  SECURED_EIN: {
    mask: 'VALUE',
    lazy: false,
    blocks: {
      VALUE: {
        mask: '00-0000000',
        blocks: {
          0: {
            mask: '0',
            displayChar: '\u2022',
          }
        }
      }
    },
  },
  ZIP: {
    mask: '00000',
    lazy: false,
  },
  EMAIL: {
    mask: 'VALUE',
    lazy: false,
    blocks: {
      VALUE: {
        mask: /^\S*@?\S*$/
      }
    }
  },
  PHONE: {
    mask: '000-000-0000',
    lazy: false
  },
  DATE_MDY_DASH: {
    mask: Date,
    pattern: 'm{-}`d{-}`Y', // default is 'd{.}`m{.}`Y'
    format: function (date: any) {
      return getDateString(date, 'MDY', '-');
    },
    parse: function (str: any) {
      return getDateObject(str, 'MDY', '-');
    },
    min: new Date(1000, 0, 1),
    lazy: false,
  },
  DATE_MDY_SLASH: {
    mask: Date,
    pattern: 'm{/}`d{/}`Y', // default is 'd{.}`m{.}`Y'
    format: function (date: any) {
      return getDateString(date, 'MDY', '/');
    },
    parse: function (str: any) {
      return getDateObject(str, 'MDY', '/');
    },
    min: new Date(1000, 0, 1),
    lazy: false,
  },
  DATE_MDY_DOT: {
    mask: Date,
    pattern: 'm{.}`d{.}`Y', // default is 'd{.}`m{.}`Y'
    format: function (date: any) {
      return getDateString(date, 'MDY', '.');
    },
    parse: function (str: any) {
      return getDateObject(str, 'MDY', '.');
    },
    min: new Date(1000, 0, 1),
    lazy: false,
  },
  DATE_DMY_DASH: {
    mask: Date,
    pattern: 'd{-}`m{-}`Y', // default is 'd{.}`m{.}`Y'
    format: function (date:any) {
      return getDateString(date, 'DMY', '-');
    },
    parse: function (str: any) {
      return getDateObject(str, 'DMY', '-');
    },
    min: new Date(1000, 0, 1),
    lazy: false,
  },
  DATE_DMY_SLASH: {
    mask: Date,
    pattern: 'd{/}`m{/}`Y', // default is 'd{.}`m{.}`Y'
    format: function (date: any) {
      return getDateString(date, 'DMY', '/');
    },
    parse: function (str: any) {
      return getDateObject(str, 'DMY', '/');
    },
    min: new Date(1000, 0, 1),
    lazy: false,
  },
  DATE_DMY_DOT: {
    mask: Date,
    pattern: 'd{.}`m{.}`Y', // default is 'd{.}`m{.}`Y'
    format: function (date: any) {
      return getDateString(date, 'DMY', '.');
    },
    parse: function (str: any) {
      return getDateObject(str, 'DMY', '.');
    },
    min: new Date(1000, 0, 1),
    lazy: false,
  },
  PERCENT: {
    mask: 'VALUE%',
    lazy: false,
    blocks: {
      VALUE: {
        mask: Number,
        scale: 2,
        signed: false,
        thousandsSeparator: ',',
        padFractionalZeros: false,
        radix: '.',
      }
    }
  },
  NUMBER: {
    mask: 'VALUE',
    lazy: false,
    blocks: {
      VALUE: {
        mask: Number,
        scale: 20,
        signed: true,
        thousandsSeparator: ',',
        padFractionalZeros: false,
        radix: '.',
      }
    }
  },
  INTEGER: {
    mask: 'VALUE',
    lazy: false,
    blocks: {
      VALUE: {
        mask: Number,
        scale: 0,
        signed: true,
        thousandsSeparator: ',',
        padFractionalZeros: false,
        radix: '.',
      }
    }
  }
};